import { atom } from "jotai";

let assistantLaunchSequence = 0;

export const assistantLaunchRequestAtom = atom(null);

const cloneJsonSafe = (value) => {
  if (value === null || value === undefined) return null;

  try {
    return JSON.parse(JSON.stringify(value));
  } catch {
    return null;
  }
};

export const createAssistantPromptRequest = ({
  integrationId,
  prompt,
  displayMessage,
  displayKind,
  displayPayload,
  threadTitle,
  autoSend = false,
}) => {
  const normalizedPrompt = String(prompt || "").trim();
  const normalizedDisplayMessage = String(displayMessage || "").trim();
  const normalizedDisplayKind = String(displayKind || "").trim();
  const normalizedThreadTitle = String(threadTitle || "").trim();

  if (!integrationId || !normalizedPrompt) return null;

  assistantLaunchSequence += 1;

  return {
    id: `${Date.now()}:${assistantLaunchSequence}`,
    integrationId,
    prompt: normalizedPrompt,
    displayMessage: normalizedDisplayMessage || null,
    displayKind: normalizedDisplayKind || null,
    displayPayload: cloneJsonSafe(displayPayload),
    threadTitle: normalizedThreadTitle || null,
    autoSend: Boolean(autoSend),
  };
};
